// SPDX-License-Identifier: AGPL-3.0-or-later

import {PlutoniumContent} from '@app/features/app/components/dialogs/components/PlutoniumContent';
import * as Modal from '@app/features/app/components/dialogs/Modal';
import {PREMIUM_PRODUCT_FULL_NAME} from '@app/features/app/config/I18nDisplayConstants';
import styles from '@app/features/premium/components/modals/PremiumModal.module.css';
import {type PremiumModalProps, usePremiumModalLogic} from '@app/features/premium/utils/PremiumModalUtils';
import {observer} from 'mobx-react-lite';
export const PremiumModal = observer(({defaultGiftMode}: PremiumModalProps) => {
	const modalLogic = usePremiumModalLogic({
		defaultGiftMode,
	});
	return (
		<Modal.Root size="large">
			<Modal.Header title={PREMIUM_PRODUCT_FULL_NAME} />
			<Modal.Content>
				<div className={styles.contentContainer}>
					<PlutoniumContent defaultGiftMode={modalLogic.defaultGiftMode} />
				</div>
			</Modal.Content>
		</Modal.Root>
	);
});
